import { Point } from './types.js';

/**
 * Returns the squared euclidean distance between two points.
 * @param p1 - The first point, which should always be an `[x, y]` formatted Array.
 * @param p2 - The second point, which should always be an `[x, y]` formatted Array.
 */
export const pointDistanceSquared = (p1: Point, p2: Point): number => {
  const dx: number = p2[0] - p1[0];
  const dy: number = p2[1] - p1[1];

  return dx * dx + dy * dy;
};
